import { CalcCostAccountingController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the cost accounting details for the calculation.
 * @example
 * ```html
 * <salaxy-calc-cost-accounting current="$ctrl.current"></salaxy-calc-cost-accounting>
 * ```
 */
export class CalcCostAccounting extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** The calculation. */
      calc: "<",
      /** Forced read only state */
      readOnly: "<",
      /**
       * Optional CostAccountingDimensionDefinitions
       * If not set, cost accounting dimensions and their options are read from the settings.
       */
      dimensions: "<",

      /**
       * Style of the inputs.
       * Supports empty or 'openClose'. Only available in not readOnly
       */
      inputMode: "@",
    };

    /** Uses the CalcCostAccountingController */
    public controller = CalcCostAccountingController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/CalcCostAccounting.html";

}
